export default __webpack_public_path__ + "static/media/Background6.9b2209b3.png";